import {IconButton, styled} from "@mui/material";
import {Popover} from "../../../misc/Popover";
import {grey, yellow} from "@mui/material/colors";
import {Link, useParams} from "react-router-dom";
import React, {useContext, useState} from "react";
import {useAlternative} from "../quote/alternative/Alternative";
import {ChangePreviewContext} from "./ShopDrawingChangePreview";
import MoreVertIcon from "@mui/icons-material/MoreVert";

export const Outer = styled("div")(() => ({
    border: "1px solid hsla(0, 100%, 100%, 0.6)",
    borderRadius: 4,
    backgroundColor: "hsla(0, 100%, 100%, 0.4)",
    color: "white",
    display: "flex",
    position: "relative",
}))

export const Element = styled("div")<{
    selected?: boolean
    locked?: boolean
}>(props => ({
    paddingLeft: 15,
    paddingRight: 15,
    paddingTop: 8,
    paddingBottom: 5,
    fontSize: "0.7rem",
    textTransform: "uppercase",
    fontWeight: 500,

    display: "flex",
    alignItems: "center",

    color: props.selected ? yellow["600"] : props.locked ? yellow["200"] : undefined,
    borderBottom: props.locked ?"2px solid " + grey["400"] :  props.selected ? "2px solid " + yellow["600"] : "2px solid transparent",
    marginBottom: -1,
    cursor: "pointer",

    "&:hover": {
        color: yellow["700"],
    },

    "&:first-of-type": {
        paddingLeft: 20,
    },
    "&:last-of-type": {
        paddingRight: 20,
    }
}))

export const Workspace = styled("div")(() => ({
    position: "absolute",
    fontSize: "0.7rem",
    top: -8,
    left: 14,
    zIndex: 1,
    paddingLeft: 2,
    paddingRight: 2,
}))

export const WorkspaceNotch = styled("div")(props => ({
    position: "absolute",
    width: "100%",
    left: 0,
    top: 7,
    height: 1,
    backgroundColor: props.theme.palette.primary.dark,
    zIndex: -1,
}))

export const ShopNav = React.memo(function ShopNav() {
    const ctx = useContext(ChangePreviewContext);
    if(ctx.enabled) {
        return (
            <Outer>
                <div style={{paddingLeft: 32, paddingRight: 32, paddingTop: 4, paddingBottom: 4}}>
                    Changeset Preview
                </div>
                <NavItem name="Openings" isIndex />
                <NavItem name="Keying" />
                <NavItem name="Hardware" />
                <NavItem name="Div10" />
                <NavItem name="Pricing" />
            </Outer>
        )
    }

    return <Outer>
        <Workspace>
            Workspace
            <WorkspaceNotch />
        </Workspace>
        <NavItem name="Openings" isIndex />
        <NavItem name="Hardware" />
        <NavItem name="Keying" />
        <NavItem name="Glazing" />
        <NavItem name="Div10" />
        <NavItem name="Misc" />
        <NavItem name="Changes" />
        <NavItem name="Logistics" />
    </Outer>
});

export function NavItem(props: {
    name: string;
    isIndex?: boolean;
    quote?: boolean;
    locked?: boolean;
    extraIcon?: any;
    onPopup?: (ctrl: {close: () => void}) => any;
}) {
    const params = useParams<{workspace: string, project: string}>();
    const routeKey = props.name.toLowerCase().replace(" ", "-");
    const alt = useAlternative();
    const previewChangeset = useContext(ChangePreviewContext);

    const [showPopup, setShowPopup] = useState<HTMLElement|null>(null);

    let to = `/project/${params.project}/shop-drawing/${routeKey}`
    if(props.quote) {
        to = `/project/${params.project}/quote/${alt}/${routeKey}`
    } else if(previewChangeset.enabled) {
        to = `/project/${params.project}/shop-drawing/changeset/${previewChangeset.sessionId}/preview/${routeKey}`
    }

    const selected = params.workspace === routeKey || (!params.workspace  && props.isIndex);

    const main = <Link style={{textDecoration: "none", color: "inherit"}} to={to}>
        <Element locked={props.locked}
                 selected={selected}
                 style={{
                     paddingRight: props.onPopup ? 0 : undefined,
                 }}
        >
            {props.name}
        </Element>
    </Link>

    let out = main;

    if(props.onPopup) {
        out = (
            <div style={{display: "flex", alignItems: "stretch"}}>
                {main}
                {(!!props.onPopup) && <div style={{
                    fontSize: "0.7rem",
                    display: "flex",
                    alignItems: "center",
                    borderBottom: props.locked ? "2px solid " + grey["400"] :  selected ? "2px solid " + yellow["600"] : "2px solid transparent",
                    position: "relative",
                    top: 1,
                    marginLeft: 4,
                }}>
                    {props.extraIcon}
                    <IconButton size="small" onClick={e => setShowPopup(e.currentTarget as any)}>
                        <MoreVertIcon fontSize="inherit" />
                    </IconButton>
                </div>}
                {showPopup && <Popover open anchorEl={showPopup} onClose={() => setShowPopup(null)}>
                    {props.onPopup?.({
                        close: () => setShowPopup(null),
                    })}
                </Popover>}
            </div>
        )
    }

    return out;
}